import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { PrimeNGModule } from './primeng.module';
import { SharedModule } from './shared.module';
import { WellheadMovementInputsComponent } from '../perimot/components/wellhead-movement-inputs/wellhead-movement-inputs.component';

@NgModule({
  declarations: [
    WellheadMovementInputsComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    PrimeNGModule,
    SharedModule
  ],
  exports: [
    WellheadMovementInputsComponent
  ]
})
export class PerimotModule {}
